var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid40({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57,10.62V8.37A3,3,0,0,1,6,7.46,2.33,2.33,0,0,1,5.53,6,2.1,2.1,0,0,1,6.09,4.5a2.22,2.22,0,0,1,1.48-.69V3.27h.78v.54a2.27,2.27,0,0,1,1.36.58,2.26,2.26,0,0,1,.64,1.29L9,5.85A1.1,1.1,0,0,0,8.35,5v2.1A3.49,3.49,0,0,1,10.1,8a2.13,2.13,0,0,1,.47,1.42A2.39,2.39,0,0,1,10,11.06a2.56,2.56,0,0,1-1.63.82v1H7.57v-1a2.51,2.51,0,0,1-1.51-.7,2.76,2.76,0,0,1-.74-1.63l1.4-.16a1.82,1.82,0,0,0,.32.75A1.59,1.59,0,0,0,7.57,10.62ZM7.57,5a1,1,0,0,0-.51.36,1,1,0,0,0-.18.57.86.86,0,0,0,.17.53,1.15,1.15,0,0,0,.52.4Zm.78,5.71A1.07,1.07,0,0,0,9,10.32a1,1,0,0,0,.25-.7A1,1,0,0,0,9,9a1.28,1.28,0,0,0-.69-.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid40);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_40.b17c96c0e578313daa31ea56cc95ca36.svg";
export { ForwardRef as ReactComponent };